module.exports = __webpack_public_path__ + "static/hero-03b6b67927eb0931413effefa3440848.jpg";